module.exports = __webpack_public_path__ + "img/contact-bg2.b6bf9172.png";